module.exports = __webpack_public_path__ + "static/media/wash_hygiene_map_important.4b21de51.svg";